/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-contouring.reducer';

export const TreatmentContouringDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentContouringEntity = useAppSelector(state => state.treatmentContouring.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentContouringDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentContouring.detail.title">TreatmentContouring</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentContouring.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentContouringEntity.id}</dd>
          <dt>
            <span id="structureName">
              <Translate contentKey="tinyMedicRestApp.treatmentContouring.structureName">Structure Name</Translate>
            </span>
          </dt>
          <dd>{treatmentContouringEntity.structureName}</dd>
          <dt>
            <span id="contourData">
              <Translate contentKey="tinyMedicRestApp.treatmentContouring.contourData">Contour Data</Translate>
            </span>
          </dt>
          <dd>{treatmentContouringEntity.contourData}</dd>
          <dt>
            <span id="contouringDate">
              <Translate contentKey="tinyMedicRestApp.treatmentContouring.contouringDate">Contouring Date</Translate>
            </span>
          </dt>
          <dd>{treatmentContouringEntity.contouringDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentContouring.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentContouringEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentContouring.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentContouringEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentContouring.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentContouringEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentContouring.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentContouringEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentContouring.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentContouringEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentContouring.plan">Plan</Translate>
          </dt>
          <dd>{treatmentContouringEntity.plan ? treatmentContouringEntity.plan.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-contouring" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-contouring/${treatmentContouringEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentContouringDetail;
